import React from "react";
import { Box, Modal, Card, CardContent, CardActions, Button, Typography, } from "@mui/material";
const ResultWarning = ({ open, onClose, warningMessage, }) => {
    return (React.createElement(Modal, { open: open, onClose: onClose },
        React.createElement(Card, { sx: { maxWidth: 400, margin: "auto", mt: 10, border: "1px solid rgb(255, 196, 0)" } },
            React.createElement(Box, { sx: { bgcolor: "#004400", color: "FF0000", p: 2, textAlign: "center" } },
                React.createElement(Typography, { variant: "h6", sx: { color: "#ffffff", fontWeight: "bold" } }, "Trial Warning")),
            React.createElement(CardContent, null,
                React.createElement(Typography, { variant: "body1", sx: { textAlign: "center" } }, warningMessage)),
            React.createElement(CardActions, { sx: { display: "flex", justifyContent: "center" } },
                React.createElement(Button, { onClick: onClose, variant: "contained", color: "primary" }, "I Understand")))));
};
export default ResultWarning;
